import Flex from '@components/Flex/Flex';
import { lighten, styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  flex: 1,
  border: `1px solid ${theme.palette.primary.main}`,
  backgroundColor: lighten(theme.palette.primary[100], 0.5),
  borderRadius: '8px',
  minWidth: 230,
  padding: theme.spacing(5),
  flexDirection: 'column',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    minWidth: 150,
  },
}));
